import FIcon from "@components/FIcon";
import { CONTENT_REVIEW_STATUS } from "@pages/campaigns/content-review/statuses";
import { ParticipantRecord } from "types/creator-view";

// Function to check if deliverable needs submission
const getUnsubmittedDeliverables = (participantRecord: ParticipantRecord) => {
  if (!participantRecord || !participantRecord.deliverables) return [];

  return participantRecord.deliverables.filter((deliverable) => {
    // Find the corresponding content in content_review
    const { content_review } = participantRecord;
    if (!content_review || !content_review.deliverables) return false;

    const contentReviewDeliverable = content_review.deliverables.find(
      (d) => d.id === deliverable.content_review_id
    );

    // Skip if no content review deliverable exists
    if (!contentReviewDeliverable || !contentReviewDeliverable.content)
      return false;

    // Check if content exists, has rounds with assets, but is not submitted
    const { content } = contentReviewDeliverable;
    const { rounds = [], status } = content;

    // Check if there are any rounds with assets
    const hasAssets = rounds.some(
      (round) => round.assets && round.assets.length > 0
    );

    // Only include deliverables that have content/assets and are not submitted
    return (
      rounds.length > 0 &&
      hasAssets &&
      status === CONTENT_REVIEW_STATUS.NOT_SUBMITTED
    );
  });
};

interface SubmitDeliverablesAlertProps {
  participant: ParticipantRecord;
  onGoToSubmit: () => void;
}

const SubmitDeliverablesAlert = ({
  participant,
  onGoToSubmit,
}: SubmitDeliverablesAlertProps) => {
  const unsubmittedDeliverables = getUnsubmittedDeliverables(participant);

  if (!unsubmittedDeliverables.length) {
    return null;
  }

  return (
    <div className="top-0 z-50 bg-red text-white py-2 px-4 shadow-md">
      <div className="container mx-auto flex justify-center text-sm items-center gap-4">
        <div className="flex items-center">
          <FIcon icon="warning-2" size={18} color="#FFFFFF" className="mr-2" />
          <span>
            You have {unsubmittedDeliverables.length} unsubmitted{" "}
            {unsubmittedDeliverables.length === 1
              ? "deliverable"
              : "deliverables"}
            :&nbsp;
            {unsubmittedDeliverables.map((deliverable, index) => (
              <span key={deliverable.id} className="font-medium">
                {deliverable.name || `Deliverable ${index + 1}`}
                {index < unsubmittedDeliverables.length - 1 ? ", " : ""}
              </span>
            ))}
          </span>
        </div>
        <button
          onClick={onGoToSubmit}
          className="text-white font-medium hover:underline flex items-center pt-[3px] pb-[2px] px-3 border border-white rounded"
        >
          Submit Now
          <FIcon
            icon="arrow-right"
            size={16}
            color="#FFFFFF"
            className="ml-1"
          />
        </button>
      </div>
    </div>
  );
};

export default SubmitDeliverablesAlert;
